import ApiService from '@apis/ApiService';
import type {
  SubmitRequestPayload,
  SupportRequestResponse,
} from '@customTypes/support/supportRequest';

class SupportService {
  public async submitSupportRequest(
    requestPayload: SubmitRequestPayload,
  ): Promise<SupportRequestResponse> {
    const { data, error } = await ApiService.post<
      SubmitRequestPayload,
      SupportRequestResponse
    >(`/support`, requestPayload);

    if (data) {
      return data;
    } else {
      throw new Error(error || 'Failed to submit request');
    }
  }
}

export default new SupportService();
